import axios from 'axios';
import React from 'react';
import { Col, Row, Space, Typography } from 'antd';
import { SystemApi } from '../../services/Api';
import PanelCpu from './system/PanelCpu';
// import PanelHd2 from './system/PanelHd2';
import PanelHd3 from './system/PanelHd3';
import PanelSigniture from './system/PanelSigniture';
import PanelUser from './system/PanelUser';

interface SystemContentProps {
    trans: (key: string) => string;
    handleError?: (title: string, info: string) => void;
    handleConfirm?: (title: string, info: string, op: () => void) => void;
    fileList?: unknown[];
    appList?: unknown[];
}

interface SystemContentState {
    loading: boolean;
}

interface PanelRef {
    updateInfo?: (info: any) => void;
    updateCertInfo?: (info: any) => void;
}

export default class SystemContent extends React.Component<SystemContentProps, SystemContentState> {
    state: SystemContentState = {
        loading: false,
    };

    childCert = React.createRef<PanelSigniture>();
    childCpu = React.createRef<PanelCpu>();
    // childHd2 = React.createRef<PanelHd2>();
    childHd3 = React.createRef<PanelHd3>();
    childUser = React.createRef<PanelUser>();

    componentDidMount() {
        void this.getSystemInfo();
    }

    getSystemInfo = async () => {
        const { trans: t, handleError } = this.props;
        const lang = localStorage.getItem('lang') || 'zh_CN';

        this.setState({ loading: true });

        try {
            const response = await axios.post(SystemApi.GET_SYSTEM_INFO, {
                lang: lang.split('_')[0],
            });

            const data = response.data?.data;
            if (!data) {
                return;
            }

            if (data.cert) {
                this.childCert.current?.updateCertInfo(data.cert);
            }
            if (data.cpu) {
                this.childCpu.current?.updateInfo(data.cpu);
            }
            if (data.hd) {
                // this.childHd2.current?.updateInfo(data.hd);
                this.childHd3.current?.updateInfo(data.hd);
            }
            if (data.account || data.user) {
                this.childUser.current?.updateInfo(data.account || {}, data.user || {});
            }
        } catch (error: any) {
            console.error('SystemContent.getSystemInfo()', error);
            handleError?.(
                t('serverError'),
                error?.response?.data?.message || error?.message || String(error),
            );
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { trans: t } = this.props;

        return (
            <main
                style={{
                    padding: 16,
                    background: 'var(--content-bg, #f5f5f5)',
                    minHeight: 'calc(100vh - 64px)',
                }}
            >
                <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    <Typography.Title level={2} style={{ margin: 0 }}>
                        {t('systemMgmt')}
                    </Typography.Title>

                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={12}>
                            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                <PanelSigniture trans={t} ref={this.childCert} />
                                {/* <PanelHd2 trans={t} ref={this.childHd2} /> */}
                                <PanelHd3 trans={t} ref={this.childHd3} />
                            </Space>
                        </Col>

                        <Col xs={24} lg={12}>
                            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                <PanelUser trans={t} ref={this.childUser} />
                                <PanelCpu trans={t} ref={this.childCpu} />
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </main>
        );
    }
}
